export interface OtherOptions {
  spacing: number
}

const other: OtherOptions = {
  spacing: 8,
}

export default other
